import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-516426da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-access" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-access" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_1')) + " ", 1),
              _createVNode(_component_LinkButton, {
                href: "https://vrchat.com/home/user/usr_bbdddc8e-e329-4764-8fc1-65e414cfddfd",
                "is-external": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'link_1')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_SignalText, { signal: "caution" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'caution_1')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_2')), 1),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'li_3')) + " ", 1),
              _createVNode(_component_SignalText, { signal: "caution" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'caution_2_1')), 1),
                  _createVNode(_component_router_link, { to: "/faq_contact" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'link_2')), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_1', 'caution_2_2')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_Heading, { tag: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'h2_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'p_1')), 1),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'h3_1')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text(
              'group_2',
              'permanent_instance',
              'li_1',
              'text_1',
            )), 1),
              _createVNode(_component_router_link, { to: "/access/instances" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'li_1', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'li_1', 'text_2')), 1)
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'li_2')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'li_3')), 1),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'caution_2')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'permanent_instance', 'caution_3')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_Heading, { tag: "h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'h3_2')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("ol", null, [
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_1', 'text_1')), 1),
              _createVNode(_component_router_link, { to: "/program" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_1', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_1', 'text_2')), 1)
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_2')), 1),
            _createElementVNode("li", null, [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_3', 'text_1')), 1),
              _createVNode(_component_router_link, { to: "/access/instances" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_3', 'link')), 1)
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_3', 'text_2')), 1)
            ]),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_4')), 1),
            _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'li_5')), 1),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'caution_1')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'caution_2')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('group_2', 'event_instance', 'caution_3')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}